import { Button } from "@shared/ui/button";
import { Plus } from "lucide-react";

interface EmptyStateProps {
  onCreateNew: () => void;
}

export const EmptyState = ({ onCreateNew }: EmptyStateProps) => {
  return (
    <div className="text-center py-16 border-2 border-dashed border-gray-200 rounded-lg bg-white">
      <div className="mx-auto h-24 w-24 flex items-center justify-center rounded-full bg-slate-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-slate-400"
        >
          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <line x1="10" y1="9" x2="8" y2="9" />
        </svg>
      </div>
      <h3 className="mt-4 text-lg font-semibold text-gray-900">
        No templates yet
      </h3>
      <p className="mt-1 text-gray-500">
        Create your first template to start customizing bills.
      </p>
      <div className="mt-6">
        <Button onClick={onCreateNew} className="bg-sky-600 hover:bg-sky-700">
          <Plus className="h-4 w-4 mr-2" />
          Create First Template
        </Button>
      </div>
    </div>
  );
};
